// Error
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const REQUEST_SMS_ERROR = 'REQUEST_SMS_ERROR';
export const INVALID_VALIDATION_CODE = 'INVALID_VALIDATION_CODE';
export const SUBSCRIBE_MSISDN_ERROR = 'SUBSCRIBE_MSISDN_ERROR';
export const SUBSCRIBE_NO_CREDITS = 'FAIL';
export const SUBSCRIBE_GENERAL_ERROR = 500;



// WEBPACK FOOTER //
// ./src/actions/error-actions.js